
import React from 'react';
import { motion } from 'framer-motion';
import { socialLinks } from '../constants';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-zinc-900 mt-8 py-6 text-center text-gray-400">
      <div className="container mx-auto px-4">
        <div className="flex justify-center space-x-2 mb-4">
          {socialLinks.map((link) => (
            <motion.a
              key={link.name}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative"
              aria-label={link.name}
              whileHover={{ 
                scale: 1.15,
                y: -3
              }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              <div className="absolute inset-0 rounded-full blur-lg bg-sky-500/15 group-hover:bg-sky-400/30 transition-all duration-300" />
              <div className="relative bg-black/20 backdrop-blur-sm rounded-full p-2 border border-white/5 group-hover:border-sky-400/30 transition-all duration-300">
                {link.type === 'image' ? (
                  <img 
                    src={link.icon} 
                    alt={link.name} 
                    className="h-6 w-6 object-contain filter brightness-90 group-hover:brightness-100 transition-all duration-300"
                    loading="lazy"
                  />
                ) : (
                  <svg
                    className="h-6 w-6 text-gray-400 group-hover:text-sky-400 transition-colors duration-300"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d={link.icon} />
                  </svg>
                )}
              </div>
            </motion.a>
          ))}
        </div>
        <p className="text-sm">
          © 2022-2026 Sangam Panta
        </p>
      </div>
    </footer>
  );
};
